import { SideNavButton } from './SideNavButton';

export const ModuleButton = ({ menu, onClick, isActive }) => {
  const label = menu.shortName ?? menu.displayName;
  return <SideNavButton onClick={() => onClick(menu)} icon={menu.icon} size="2x" label={label} isActive={isActive} />;
};
